/**
 * @generated SignedSource<<cab550845cbd4b29175646946f7a6988>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentHeaderPresence_contentSettingReader$data = {
  readonly isEnabledOnContentView: boolean;
  readonly " $fragmentType": "ContentHeaderPresence_contentSettingReader";
};
export type ContentHeaderPresence_contentSettingReader$key = {
  readonly " $data"?: ContentHeaderPresence_contentSettingReader$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentHeaderPresence_contentSettingReader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "ContentHeaderPresence_contentSettingReader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEnabledOnContentView"
    }
  ],
  "type": "ConfluenceTeamPresence"
};

(node as any).hash = "fbde27a433ce8000d3c1b41115f9f601";

export default node;
